import styled from "styled-components";
import { COLORS, FONT_SIZE, FONTS } from "../../../../constants/Styles";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const BinInventoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
`;

export const Title = styled.div`
  font-size: ${FONT_SIZE.size32};
  font-family: ${FONTS.spaceGrotesk};
  margin-bottom: 1rem;
  text-align: center;
`;

export const SubTitle = styled.div`
  font-size: ${FONT_SIZE.size24};
  font-family: ${FONTS.body};
  color: ${COLORS.secondaryLight};
  text-align: center;
`;

export const ActionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  flex-direction: column;
`;

export const BinFiltersFormContainer = styled.form`
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
`;
